import { render, staticRenderFns } from "./webhook.banner.vue?vue&type=template&id=4fa8d0bb&"
import script from "./webhook.banner.vue?vue&type=script&lang=js&"
export * from "./webhook.banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports